import React from 'react'
import Draggable from "../../../DnD/Draggable";

function Area({id, name, className = "", amount}) {
    const array = [...Array(amount)];

    return (
        <Draggable id={id}>
            <div className="area">
                {name}
                <div className={className}>
                    {array.map((_, i) => (
                        <div key={i} className="box"/>
                    ))}
                </div>
            </div>
        </Draggable>
    )
}

export default Area
